/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'common.applicationTitle': {
    id: 'common.applicationTitle',
    defaultMessage: 'Media Library Widget Demo',
  },
  'demo.tabSettings.label': {
    id: 'demo.tabSettings.label',
    defaultMessage: 'Settings',
  },
  'demo.tabCode.label': {
    id: 'demo.tabCode.label',
    defaultMessage: 'Code',
  },
  'demo.section.general': {
    id: 'demo.section.general',
    defaultMessage: 'General',
  },
  'demo.section.general.cloudName': {
    id: 'demo.section.general.cloudName',
    defaultMessage: 'Cloud name',
  },
  'demo.section.general.changeCloud': {
    id: 'demo.section.general.changeCloud',
    defaultMessage: 'Change cloud',
  },
  'demo.section.general.reset': {
    id: 'demo.section.general.reset',
    defaultMessage: 'Reset',
  },
  'demo.section.clientSideDesign': {
    id: 'demo.section.clientSideDesign',
    defaultMessage: 'Client-side Design',
  },
  'demo.section.clientSideDesign.openMediaLibraryInline': {
    id: 'emo.section.clientSideDesign.openMediaLibraryInline',
    defaultMessage: 'Open Media library inline',
  },
  'demo.section.clientSideDesign.hideCloudinaryHeader': {
    id: 'demo.section.clientSideDesign.hideCloudinaryHeader',
    defaultMessage: 'Hide the Cloudinary header',
  },
  'demo.section.clientSideDesign.insertButtonCaption': {
    id: 'demo.section.clientSideDesign.insertButtonCaption',
    defaultMessage: 'Insert button caption',
  },
  'demo.section.insertedMedia': {
    id: 'demo.section.insertedMedia',
    defaultMessage: 'Inserted Media',
  },
  'demo.section.insertedMedia.info': {
    id: 'demo.section.insertedMedia.info',
    defaultMessage: 'Any selected transformations will only be applied if you insert an image',
  },
  'demo.section.insertedMedia.emptyContainerInfo': {
    id: 'demo.section.insertedMedia.emptyContainerInfo',
    defaultMessage: 'Inserted media appears here',
  },
  'demo.section.selection': {
    id: 'demo.section.selection',
    defaultMessage: 'Asset Selection',
  },
  'demo.section.maximumAssets': {
    id: 'demo.section.maximumAssets',
    defaultMessage: 'Maximum number of assets',
  },
  'demo.section.transformation': {
    id: 'demo.section.transformation',
    defaultMessage: 'Select Image Transformations',
  },
  'demo.section.transformation.infoMessage': {
    id: 'demo.section.transformation.infoMessage',
    defaultMessage: 'Example transformations to be applied',
  },
  'demo.section.transformation.custom.label': {
    id: 'demo.section.transformation.custom.label',
    defaultMessage: 'Custom',
  },
  'demo.section.transformation.custom.placeholder': {
    id: 'demo.section.transformation.custom.placeholder',
    defaultMessage: '(Click enter to apply)',
  },
  'demo.section.filter': {
    id: 'demo.section.filter',
    defaultMessage: 'Open Console (show)',
  },
  'demo.section.filter.search': {
    id: 'demo.section.filter.search',
    defaultMessage: 'Search',
  },
  'demo.section.filter.folder.label': {
    id: 'demo.section.filter.folder.label',
    defaultMessage: 'Folder',
  },
  'demo.section.filter.folder.placeholder': {
    id: 'demo.section.filter.folder.placeholder',
    defaultMessage: 'Folder (Click enter to apply)',
  },
  'demo.section.filter.filterByAssetType': {
    id: 'demo.section.filter.filterByAssetType',
    defaultMessage: 'Filter by asset type',
  },
  'demo.section.filter.filterByCustomExpression': {
    id: 'demo.section.filter.filterByCustomExpression',
    defaultMessage: 'Custom expression',
  },
  'demo.section.filter.filterByCustomExpressionPlaceholder': {
    id: 'demo.section.filter.filterByCustomExpressionPlaceholder',
    defaultMessage: 'File size, format, dimensions, etc.',
  },
  'demo.codeSection.embedCode.title': {
    id: 'demo.codeSection.embedCode.title',
    defaultMessage: 'Embed Code',
  },
  'demo.codeSection.embedCode.copyCodeToClipboard': {
    id: 'demo.codeSection.embedCode.copyCodeToClipboard',
    defaultMessage: 'Copy Code to Clipboard',
  },
  'demo.codeSection.embedCode.afterCopyTooltip': {
    id: 'demo.codeSection.embedCode.afterCopyTooltip',
    defaultMessage: 'Copied',
  },
  'demo.codeSection.consoleResponse.title': {
    id: 'demo.codeSection.consoleResponse.title',
    defaultMessage: 'Console Response',
  },
  'demo.codeSection.consoleResponse.clearResponse': {
    id: 'demo.codeSection.consoleResponse.clearResponse',
    defaultMessage: 'Clear Response',
  },
  'landing.signUpForFree': {
    id: 'landing.signUpForFree',
    defaultMessage: 'SIGN UP FOR FREE',
  },
  'landing.h1': {
    id: 'landing.h1',
    defaultMessage: 'Media Library',
  },
  'landing.header.intro': {
    id: 'landing.header.intro',
    defaultMessage:
      'Utilize the Media Library widget in your CMS or web app allowing users to effortlessly upload, manage, and transform assets. Enable publishing, sharing, optimization, and automated transformation of assets with the powerful digital asset management capabilities included.',
  },
  'landing.header.videoTitle': {
    id: 'landing.header.videoTitle',
    defaultMessage: 'Introduction video',
  },
  'landing.header.tryItNow': {
    id: 'landing.header.tryItNow',
    defaultMessage: 'TRY IT NOW',
  },
  'landing.header.links.overview': {
    id: 'landing.header.links.overview',
    defaultMessage: 'Overview',
  },
  'landing.header.links.demo': {
    id: 'landing.header.links.demo',
    defaultMessage: 'Demo',
  },
  'landing.header.links.documentation': {
    id: 'landing.header.links.documentation',
    defaultMessage: 'Documentation',
  },
  'landing.embedSection.heading': {
    id: 'landing.embedSection.heading',
    defaultMessage: 'Embed',
  },
  'landing.embedSection.text': {
    id: 'landing.embedSection.text',
    defaultMessage:
      'Easily integrate the Media Library widget into your CMS or web app allowing users to effortlessly upload, manage, and transform assets. Enable publishing, sharing, optimization, and transformation of assets with the powerful digital asset management capabilities included.',
  },
  'landing.embedSection.tooltip': {
    id: 'landing.embedSection.tooltip',
    defaultMessage: 'Click to try it yourself',
  },
  'landing.tabsSection.heading': {
    id: 'landing.tabsSection.heading',
    defaultMessage: 'Media Library Widget Intro',
  },
  'landing.tabsSection.learnMore': {
    id: 'landing.tabsSection.learnMore',
    defaultMessage: 'LEARN MORE',
  },
  'landing.tabsSection.tabs.labels.manage': {
    id: 'landing.tabsSection.tabs.labels.manage',
    defaultMessage: 'Manage',
  },
  'landing.tabsSection.tabs.labels.transform': {
    id: 'landing.tabsSection.tabs.labels.transform',
    defaultMessage: 'Transform',
  },
  'landing.tabsSection.tabs.labels.customize': {
    id: 'landing.tabsSection.tabs.labels.customize',
    defaultMessage: 'Customize',
  },
  'landing.tabsSection.tabs.labels.authenticate': {
    id: 'landing.tabsSection.tabs.labels.authenticate',
    defaultMessage: 'Authenticate',
  },
  'landing.tabsSection.tabs.texts.manage': {
    id: 'landing.tabsSection.tabs.texts.manage',
    defaultMessage:
      'Quickly find assets with advanced search, get cross-team approvals via commenting, share assets externally via collections, or generate zip files for bulk downloading.',
  },
  'landing.tabsSection.tabs.texts.transform': {
    id: 'landing.tabsSection.tabs.texts.transform',
    defaultMessage:
      'Automatically create asset variants upon upload or directly within the Media Library by applying optimization and transformation settings such as format, resizing, water marks, cropping mode, and many other options.',
  },
  'landing.tabsSection.tabs.texts.customize': {
    id: 'landing.tabsSection.tabs.texts.customize',
    defaultMessage:
      'Display the widget as a modal dialog or inline in your application with the options to further customize elements by supplying a custom button class, specifying button text, or hiding the Cloudinary logo banner.',
  },
  'landing.tabsSection.tabs.texts.authenticate': {
    id: 'landing.tabsSection.tabs.texts.authenticate',
    defaultMessage: 'Enable users to securely log in to Cloudinary via an authentication signature or your organization’s SAML-based SSO provider.',
  },
  'landing.linksSection.heading': {
    id: 'landing.linksSection.heading',
    defaultMessage: 'Integrated with CMS leaders',
  },
  'landing.footer.links.termsOfUse': {
    id: 'landing.footer.links.termsOfUse',
    defaultMessage: 'Terms of use',
  },
  'landing.footer.links.privacyPolicy': {
    id: 'landing.footer.links.privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
  'landing.footer.links.documentation': {
    id: 'landing.footer.links.documentation',
    defaultMessage: 'Documentation',
  },
  'landing.footer.links.contactUs': {
    id: 'landing.footer.links.contactUs',
    defaultMessage: 'Contact Us',
  },
  'landing.footer.copyright': {
    id: 'landing.footer.copyright',
    defaultMessage: '2020 Cloudinary. All rights reserved',
  },
  'loginModal.intro.heading': {
    id: 'loginModal.intro.heading',
    defaultMessage: 'Media Library Widget Interactive Demo',
  },
  'loginModal.intro.text': {
    id: 'loginModal.intro.text',
    defaultMessage: 'Quickly find assets with advanced search, get cross-team approvals via commenting, share assets externally via collections, or generate zip files for bulk downloading',
  },
  'loginModal.main.accountCredentials.label': {
    id: 'loginModal.main.accountCredentials.label',
    defaultMessage: 'Account Credentials',
  },
  'loginModal.main.accountCredentials.text': {
    id: 'loginModal.main.accountCredentials.text',
    defaultMessage: 'Enter your Cloudinary details to load the demo',
  },
  'loginModal.main.accountCredentials.inputs.cloudName.label': {
    id: 'loginModal.main.accountCredentials.inputs.cloudName.label',
    defaultMessage: 'Cloud Name',
  },
  'loginModal.main.accountCredentials.inputs.apiKey.label': {
    id: 'loginModal.main.accountCredentials.inputs.apiKey.label',
    defaultMessage: 'API key',
  },
  'loginModal.main.accountCredentials.cantFindApiKey': {
    id: 'loginModal.main.accountCredentials.cantFindApiKey',
    defaultMessage: 'Can\'t find the API key?',
  },
  'loginModal.main.accountCredentials.start': {
    id: 'loginModal.main.accountCredentials.start',
    defaultMessage: 'Start',
  },
  'loginModal.main.signUp.label': {
    id: 'loginModal.main.signUp.label',
    defaultMessage: 'Signup For Free',
  },
});
